import './styles/main.sass'

import { bootstrap } from './app/bootstrap.tsx'

const container = document.getElementById('root')

if (container !== null) {
  bootstrap(container, window.location.pathname)
}
